import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { invalidateTaskCounts } from '@/pages/authenticated/home/utils/invalidateTaskCounts';

const useRejectSalesOrderDraft = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  const queryClient = useQueryClient();

  return useMutationApi<void>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/reject`,
    method: 'POST',
    options: {
      onSuccess: () => {
        // Invalidate home page task counts
        invalidateTaskCounts(queryClient);
        // Call consumer's onSuccess callback
        onSuccess?.();
      },
    },
  });
};

export default useRejectSalesOrderDraft;
